import { render, staticRenderFns } from "./telecontrol.vue?vue&type=template&id=62254f6f"
import script from "./telecontrol.vue?vue&type=script&lang=js"
export * from "./telecontrol.vue?vue&type=script&lang=js"
import style0 from "./telecontrol.vue?vue&type=style&index=0&id=62254f6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports